import { render, staticRenderFns } from "./mainList.vue?vue&type=template&id=39f19754&scoped=true"
import script from "./mainList.vue?vue&type=script&lang=js"
export * from "./mainList.vue?vue&type=script&lang=js"
import style0 from "./mainList.vue?vue&type=style&index=0&id=39f19754&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f19754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f19754')) {
      api.createRecord('39f19754', component.options)
    } else {
      api.reload('39f19754', component.options)
    }
    module.hot.accept("./mainList.vue?vue&type=template&id=39f19754&scoped=true", function () {
      api.rerender('39f19754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainList.vue"
export default component.exports